import { IMessage } from '@shared/models/proto/base/messages'

import { UserType } from '@protos/user_type_pb'

export const isPatientMessage = (message: IMessage) => {
  const patientOrVisitorList = [
    UserType.VISITOR,
    UserType.PATIENT,
    UserType.VIDEO_CALL_GUEST,
    UserType.QLIQ_MESSAGE_URL,
  ]
  return patientOrVisitorList.includes((message.sender?.type ?? '') as UserType)
}
